import React, { useState } from "react";
import Allproduk from "../../Components/About/allProduk";
import NavbarThree from "../../Components/Navbar/navbarThree";

const ProdukPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div className="font-montserrat">
      <NavbarThree isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <div className="pt-20 bg-gray-100">
        <Allproduk />
      </div>
    </div>
  );
};

export default ProdukPage;
